<template>
  <div>
    <the-header />
    <div class="main">
      <call-menu />
      <div class="content">
        <LoadingOverlay />
        <div
          v-if="computedBreadCrumbs.length === 1"
          class="name-page">
          {{ computedBreadCrumbs[0].name }}
        </div>
        <div
          v-else
          class="breadcrumb">
          <span
            v-for="(item, index) in computedBreadCrumbs"
            :key="item.name+item.routeName">
            <span v-if="item.routeName">
              <span
                class="breadcrumb__item"
                style="color:#28a745;font-family: cera-regular;cursor: pointer"
                @click="clickGotTo(item)">
                {{ tempRouteName(item.name) }}
              </span>

              <font-awesome-icon
                v-if="computedBreadCrumbs.length - 1 !== index"
                :icon="dataIconRight" />
            </span>
            <span
              v-else
              class="breadcrumb__item">
              {{ tempRouteName(item.name) }}
              <font-awesome-icon
                v-if="item.editIcon"
                style="font-size: 16px; color: #28a745; cursor: pointer;"
                :icon="dataIconPen"
                @click="() => $root.$emit('clickEditIcon', tempRouteName(item.name))" />
              <font-awesome-icon
                v-if="computedIsProject"
                style="font-size: 16px; color: #28a745; cursor: pointer;"
                :icon="dataIconPen"
                @click="() => $root.$emit('clickEditProjectNameIcon')" />
              <b-badge
                v-if="computedIsVip"
                variant="vip">
                VIP
              </b-badge>
            </span>
          </span>
        </div>
        <router-view />
        <call-modal-logout v-model="dataModalLogout" />
      </div>
    </div>
    <div class="footer" />
  </div>
</template>

<script>
import TheHeader from '../components/TheHeader';
import CallMenu from '../components/desktop/CallMenu';
import { faAngleRight, faPen } from '@fortawesome/pro-regular-svg-icons';
import CallModalLogout from '../components/common/modals/CallLogout';
import LoadingOverlay from '../components/common/LoadingOverlay';
import { BBadge } from 'bootstrap-vue';

export default {
  name: 'AppLayout',
  components: {
    CallModalLogout,
    LoadingOverlay,
    CallMenu,
    TheHeader,
    BBadge
  },
  data () {
    return {
      dataIconRight: faAngleRight,
      dataIconPen: faPen,
      dataModalLogout: false
    };
  },
  computed: {
    computedBreadCrumbs () {
      return this.$route.meta.breadCrumbs;
    },

    computedIsVip () {
      const parseVip = typeof this.$route.query?.isVip === 'string'
        ? JSON.parse(this.$route.query?.isVip)
        : this.$route.query?.isVip;
      return parseVip && this.$route.name === 'ProjectTasks';
    },

    computedIsProject () {
      const projectName = this.$route.query?.projectName;
      return typeof projectName === 'string' && this.$route.name === 'ProjectTasks';
    }
  },
  async mounted () {
    this.$root.$on('logout', () => {
      this.dataModalLogout = true;
    });
  },
  methods: {
    tempRouteName (name = '') {
      if (!name || name[0] !== ':') {
        return name;
      }

      const keys = name.substring(1).split('.');

      let value = this.$route.query[keys.shift()];

      // Если это JSON-строка — парсим
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch (e) {
          // не JSON — оставляем как есть
        }
      }

      for (const key of keys) {
        if (value == null) {
          return '';
        }
        value = value[key];
      }

      return value ?? '';
    },
    clickGotTo ({ routeName }) {
      this.$router.push({
        name: routeName,
        query: this.$route.query
      });
    }
  }
};
</script>
